import { head, tail } from 'ramda'

const nextCallbackGenerator = (middleware, apply) => (content, ...args) => {
  const current = head(middleware)
  if (!current) {
    return content
  }
  return apply(
    current,
    nextCallbackGenerator(tail(middleware), apply),
    content,
    ...args
  )
}

export class ToHTMLConverterMiddlewareManager {
  _middleware = []

  add(middleware) {
    this._stylesContext = {}
    this._middleware.push(middleware)
  }

  iterateOverMiddleware(apply, content, ...args) {
    if (!this._middleware || this._middleware.length === 0) {
      return content
    }
    return nextCallbackGenerator(this._middleware, apply)(content, ...args)
  }

  endStyles(content) {
    const apply = (middleware, callback, content, context) => {
      return middleware.endStyles(content, context, callback)
    }
    const result = this.iterateOverMiddleware(
      apply,
      content,
      this._stylesContext
    )
    this._stylesContext = {}
    return result
  }

  processStyles(content, style, block) {
    const apply = (middleware, callback, content, style, block, context) => {
      return middleware.processStyle(content, style, block, context, callback)
    }
    return this.iterateOverMiddleware(
      apply,
      content,
      style,
      block,
      this._stylesContext
    )
  }

  processEntities(content, entity) {
    const apply = (middleware, callback, content, entity) => {
      return middleware.processEntity(content, entity, callback)
    }
    return this.iterateOverMiddleware(apply, content, entity)
  }
}
